import React from 'react';
import {LoadingOutlined} from "@ant-design/icons";
import {useSelector} from "react-redux";
import {Spin} from "antd";
import './index.less';


const Loading = () => {
  const { loading }= useSelector((state) => state);

  return <Spin className="loading" spinning={!!loading.status} indicator={<LoadingOutlined />} size="large" />
}

export default Loading;